module.exports = __webpack_public_path__ + "static/media/facebook-logo-3-1.90bab5ae.png";